/*
 * Le télétravail, voulu ou imposé, prend une part de plus en plus importante dans la façon dont le travail s'effectue en France. Le problème, c'est que le télétravail, c'est pas si simple.
<br />
Mauvaise compréhension d'un besoin client, difficultés organisationnelles (réunions) ou encore sensation de blocages sont les symptômes d'un télétravail mal pratiqué...
<br />
<b>Car le télétravail, ce n'est pas naturel.</b>
 */
export const quickPresentation = `
Bien fait, il peut être bénéfique pour une entreprise et pour le télétravailleur. Mais mal fait, il peut être néfaste. Et c'est souvent le cas.
<br />
Et parce que le télétravail n'est pas naturel, il est <i>nécessaire</i> de se former à ses bonnes pratiques.
<br />
<b>83% des télétravailleurs</b> interrogés aimeraient que leurs entreprises leur offrent un coaching sur le télétravail... C'est la preuve qu'ils sont conscients que la façon dont ils pratiquent le télétravail peut se parfaire.
<br />
<b>C'est ici que j'interviens.</b>
<br />
Fort de mon expérience en télétravail, j'accompagne aujourd'hui les entreprises du numérique dans leur transition vers le travail à distance.`


/*
`Dans ce but d'aider les entreprises à télétravailler correctement, je forme managers et collaborateurs aux bonnes pratiques.
Communication, stress, organisation, espace de travail sont autant de thèmes que je traite dans ce coaching.
Côté managers, j'apporte les techniques spécifiques de gestion d'équipe, via des concepts généraux comme : veiller à la productivité tout en rassurant, apprendre à faire confiance, veiller au bien-être de son équipe, ... Mais aussi via des outils et frameworks plus concrets : logiciels de suivi, réseaux sociaux d'entreprises, sentiment d'appartenance, [...]
Côté collaborateurs, j'explique comment séparer vie pro et perso, gérer son stress ou encore organiser son espace de travail. Plus concrètement, je parle de techniques telle que Pomodoro (modifiée pour l'occasion), de la loi de Parkison, des niveaux de priorités, etc.
Cette formation s'adresse donc : aux managers, chefs de projet ou scrum master qui gèrent des équipes de développement, et aux équipes de développement elles-mêmes (développeurs, UX/UI, ...)
Si vous êtes intéressé, cliquez sur le bouton ci-dessous pour voir plus de détails sur le contenu de la formation, le prix et les modalités.`
*/
export const coursesPresentation = `
D'après une étude faite durant le confinement lié au Covid-19 auprès de télétravailleurs, près d'un tier d'entre eux ne se sent pas efficace en télétravail. 25% se sentent surchargés par le travail et autant trouvent que leurs entreprises ne gèrent pas assez bien le travail à distance.
<br /><br />
Pourtant, <b>ils sont 92% à vouloir pratiquer le télétravail de manière durable.</b>
<br /><br />
Cette dissonance entre, d'une part, la volonté marquée d'un télétravail et, d'autre part, un manque d'efficacité dans ce même télétravail, montre bien que <b>quelque chose ne fonctionne pas correctement.</b>
<br /><br />
Fort de ce constat, je propose aujourd'hui une formation et du coaching à destination des managers et collaborateurs.
Cette formation, complète, vise à assimiler les bonnes pratiques du travail à distance. Communication, stress, organisation, espace de travail sont autant de thèmes que je traite.
<br /><br />
<b>Pour les managers</b> d'abord, j'apporte les techniques spécifiques de gestion d'équipe, via des concepts généraux comme : veiller à la productivité tout en rassurant, développer la culture d'entreprises même à distance, gérer l'onboarding sans présence physique, ...
Mais aussi via des outils et frameworks plus concrets : logiciels de suivi, réseaux sociaux d'entreprises, sentiment d'appartenance, ...
<br /><br />
<b>Côté collaborateurs</b>, j'explique comment séparer vie profesionnelle et personnelle, gérer son stress ou encore organiser son espace de travail. Plus concrètement, je parle de techniques telle que Pomodoro (modifiée pour l'occasion), de la loi de Parkison, des niveaux de priorités, etc.
<br /><br />
Cette formation et ce coaching s'adresse donc : aux managers, chefs de projet ou scrum master qui gèrent des équipes de développement, et aux équipes de développement elles-mêmes (développeurs, UX/UI, ...).
`

export const whoamiPresentation = `
Développeur de formation, je suis dans le monde professionnel depuis 2013. Devenu freelance et télétravailleur en 2018, j'ai dispensé, la même année, des formation dans des écoles, entreprises ou dans le cadre de POE. Depuis 2019, je voyage dans le monde entier tout en travaillant pour des clients.
<br /><br />
Certifié Scrum Master (PSM1), j'ai autant d'expérience en tant que développeur qu'en gestion d'équipe.
<br /><br />
Avec le temps et à force de recherches, j'ai appris les bonnes pratiques du télétravail. Gestion du stress, organisation horaire, productivité, ... Tout ça n'a plus de secret pour moi.
<br /><br />
Suite à la pandémie Covid-19 et au télétravail qu'elle a imposé, j'ai décidé, fort de mon expérience, d'aider les entreprises à avoir une transition la plus douce possible vers le monde du télétravail.
<br /><br />
<p style="text-align:right;margin-right:40px;font-size:18px"><i>Alexandre Grisey</i></p>
`

export const companiesIntro = `
Parfois voulu, parfois imposé (grèves, Covid-19), le télétravail fait quoi qu'il arrive partie de l'évolution logique du mode de travail.
<br /><br />
Pratiqué depuis des années, voire décennies, dans certains pays (anglo-saxons, scandinaves), la France a pris un retard conséquent dans sa mise en place. Aussi, lorsqu'on doit passer au travail à distance, la transition n'est pas toujours simple.
<br /><br />
Déjà, pour la mise en place technique (matériel, VPN, ...), mais aussi et surtout pour les relations humaines, la bonne communication et donc, la productivité.
<br /><br />
Si vous lisez ces lignes, vous avez probablement vous-même expérimenté ces problèmes... Mauvaise compréhension d'un besoin client, difficultés organisationnelles pour les réunions ou encore sensation de blocages quelque part dans la chaine.
<br /><br />
<b>Car le télétravail, ce n'est pas naturel.</b>
<br /><br />
Bien fait, il peut être bénéfique pour une entreprise et pour le télétravailleur. D'après une enquête, 67% des développeurs se trouvent même plus efficaces en télétravail.
<br /><br />
Mais mal fait, il peut être néfaste. Pour l'entreprise comme pour le collaborateur. Stress, burn-out, mauvaise communication, ... 
<br /><br />
<br />
<div class="compnies_selling_stats">
<b>➡ 92%</b> des salariés en télétravail tiennent à garder ce mode de vie sur le long terme. Pourtant...
<br />
<b>➡ 33%</b> des néo-télétravailleurs ont rencontré des difficultés à sa mise en place qui n'étaient toujours pas résolues plusieurs semaines après...
<br />
<b>➡ 25%</b> des travailleurs à distance se sentent surchargés de travail
<br />
<b>➡ 25%</b> pensent que leurs entreprises ne gèrent pas bien le télétravail.
</div>
<br /><br />
<b>Et c'est là que j'interviens.</b>
<br /><br />
Développeur de formation, freelance, nomade et télétravailleur à temps plein, j'ai appris petit à petit à adopter les bonnes techniques de télétravail, et à les faire adopter aux clients avec lesquels j'ai travaillé.
<br /><br />
Parce que le télétravail n'est pas naturel, il est <i>nécessaire</i> de se former à ses bonnes pratiques.
<br /><br />
Selon le même sondage <b>83% des télétravailleurs</b> aimeraient que leurs entreprises leur offrent un coaching sur le télétravail... C'est la preuve qu'ils sont conscients que la façon dont ils pratiquent le télétravail peut se parfaire.
<br /><br />
C'est pour ça qu'aujourd'hui, j'aide les entreprises dans leur transition vers le travail à distance.
<br /><br />
Alors n'hésitez pas à prendre contact avec moi, ça n'engage à rien.`


export const companiesManagerList = [
    {
        "Pour les managers": "✔️ Onboarding",
        "Pour les collaborateurs": "✔️ Gestion du stress",
    },
    {
        "Pour les managers": "✔️ Culture d'entreprise",
        "Pour les collaborateurs": "✔️ Espace de travail",
    },
    {
        "Pour les managers": "✔️ Outils de communication",
        "Pour les collaborateurs": "✔️ Vie perso/pro",
    },
    {
        "Pour les managers": "✔️ Suivi efficace",
        "Pour les collaborateurs": "✔️ Techniques spécifiques (Pomodoro, Parkinson, psychologie du travail, ...)",
    },
    {
        "Pour les managers": "✔️ Techniques spécifiques (Règles des 3 'Q', ...)",
        "Pour les collaborateurs": "✔️ Communication",
    },
    {
        "Pour les managers": "...",
        "Pour les collaborateurs": "...",
    }
]

export const companiesEmployeeList = [
    {
        name: "Gestion du stress"
    },
    {
        name: ""
    },
    {
        name: ""
    },
    {
        name: ""
    }
]